import SnappPay from "@website/accommodation-ui/installment-status/assets/snapp-pay.svg";
import { InstallmentActiveModal } from "@website/accommodation-ui/installment-status/installment-active-modal";
import { InstallmentNonActiveModal } from "@website/accommodation-ui/installment-status/installment-non-active-modal";
import { useJwtToken } from "@website/hooks/auth-manager";
import { MaterialIcon } from "@website/icons/material";
import { WEBENGAGE_EVENTS } from "@website/tracking/tracking.types";
import { addEventToWebengage } from "@website/tracking/tracking.webengage";
import { Button } from "@website/ui/button";
import { Modal } from "@website/ui/modal";
import { Skeleton } from "@website/ui/skeleton";
import { deepCompare } from "@website/utils/deep-compare";
import { Login, useLoginModal } from "@website/widget/login";
import { memo, useEffect, useState } from "react";

const InstallmentStatus = ({
  isEligible,
  isLoading
}: {
  isEligible: boolean;
  isLoading: boolean;
}) => {
  const [open, setOpen] = useState(false);
  const {
    onLoginModalOpen,
    loginModalProps,
    onLoginModalClose,
    onLoginModalEnd,
    isLogin
  } = useLoginModal();

  const { phoneNumber } = useJwtToken();

  useEffect(() => {
    if (isEligible && phoneNumber) {
      addEventToWebengage(WEBENGAGE_EVENTS.PAY_BANNER_IMPRESSION, {
        "user phone number": phoneNumber
      });
    }
  }, [isEligible, phoneNumber]);
  if (isLoading) return <Skeleton height={66} />;

  if (!isLogin && !isLoading)
    return (
      <div className="bg-states-secondary-dragged border-ventures-fin-tech flex w-full justify-between rounded-xl border px-4 py-3 max-lg:flex-col lg:items-center">
        <div className="flex flex-col gap-1">
          <div className="flex gap-2">
            <img
              alt="SnappPay"
              className="max-h-5 max-w-5 rounded lg:max-h-6 lg:max-w-6"
              height={24}
              src={SnappPay.src}
              width={24}
            />
            <div className="text-subtitle-2 text-on-surface-high-emphasis">
              امکان پرداخت قسطی
            </div>
          </div>
        </div>
        <div className="flex max-lg:-mr-2 max-lg:justify-between">
          <Button
            color="secondary"
            onClick={() => setOpen(true)}
            variant="text"
          >
            جزییات بیشتر{" "}
          </Button>
          <Button
            color="secondary"
            onClick={onLoginModalOpen}
            variant="contained"
          >
            ورود{" "}
          </Button>
        </div>
        <InstallmentActiveModal open={open} setOpen={setOpen} />
        <Modal {...loginModalProps}>
          <Login onClose={onLoginModalClose} onEndAuth={onLoginModalEnd} />
        </Modal>
      </div>
    );
  if (isLogin && isEligible)
    return (
      <div>
        <div className="bg-states-secondary-dragged border-ventures-fin-tech flex w-full justify-between rounded-xl border px-4 py-3 max-lg:flex-col lg:items-center">
          <div className="flex gap-2">
            <MaterialIcon
              className="text-ventures-fin-tech max-w-5 lg:max-w-6"
              name="check_circle"
              variant="fill"
            />
            <div className="text-subtitle-2 text-on-surface-high-emphasis">
              پرداخت قسطی اسنپ‌پی شما فعال است.
            </div>
          </div>
          <div className="mt-0.5 flex justify-end max-lg:w-full">
            <Button
              color="secondary"
              onClick={() => setOpen(true)}
              variant="text"
            >
              جزییات بیشتر{" "}
            </Button>
          </div>
        </div>
        <InstallmentActiveModal open={open} setOpen={setOpen} />
      </div>
    );
  if (isLogin && !isEligible && !isLoading)
    return (
      <div className="bg-states-neutral-hover flex w-full justify-between rounded-xl px-4 py-3 max-lg:flex-col lg:items-center">
        <div className="flex gap-2">
          <MaterialIcon
            className="text-on-surface-medium-emphasis max-w-5 lg:max-w-6"
            name="info"
            variant="outlined"
          />
          <div className="text-subtitle-2 text-on-surface-high-emphasis">
            پرداخت قسطی اسنپ‌پی شما فعال نیست.
          </div>
        </div>
        <div className="mt-0.5 flex justify-end max-lg:w-full">
          <Button
            color="secondary"
            onClick={() => setOpen(true)}
            variant="text"
          >
            جزییات بیشتر
          </Button>
        </div>
        <InstallmentNonActiveModal open={open} setOpen={setOpen} />
      </div>
    );
};
export default memo(InstallmentStatus, deepCompare);
